import { render, staticRenderFns } from "./StaffAbsenceType.vue?vue&type=template&id=df222924"
import script from "./StaffAbsenceType.vue?vue&type=script&lang=js"
export * from "./StaffAbsenceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports